<nz-tabset>
    <nz-tab nzTitle="Telegram Agent">
        <app-hunter-agent-settings (afterSaved)="drawerRef.close()"></app-hunter-agent-settings>
    </nz-tab>
    <nz-tab nzTitle="Stars 🌟 for My Watchlist">
        <app-meme-star-settings (laterClicked)="drawerRef.close()" (saved)="drawerRef.close()"></app-meme-star-settings>
    </nz-tab>
    <nz-tab nzTitle="Others">
        <div class="text-sm font-medium mb-3">Set your preference</div>
        <div class="flex-between-center p-3 md:p-5 rounded-lg border border-line">
            <span class="text-sm">Allow Followers</span>
            <nz-switch
                [ngModel]="walletStatusService.userProfile?.allow_follower"
                (ngModelChange)="toggleAllowFollowers($event)"
                [disabled]="updatingAllowFollowers"
            ></nz-switch>
        </div>
    </nz-tab>
</nz-tabset>
